<div class="footer">
  If you’re experiencing a life-threatening emergency, please call 911 or the National Suicide Prevention Lifeline at
  <a href="tel:988">988</a>, or
  <a href="{{ emergencyResources }}" target="_blank">
    use these resources
  </a>
  to get immediate help.
</div>
